import { z } from "zod";
import { Region, State } from "@/gql/graphql";

export const cityValidation = z.object({
  name: z.string().min(2, "Name must be at least 2 characters long"),
  slug: z
    .string()
    .min(2, "Slug must be at least 2 characters long")
    .regex(
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      "Slug must contain only lowercase letters, numbers, and hyphens",
    ),
  region: z.enum(Region).refine((r) => r, { message: "Region is required" }),
  state: z.enum(State).refine((s) => s, { message: "State is required" }),
  timezone: z.string(),
});
